<template>
  <div class="DemandPoolListEmpty inner_center">

    <div class="empty-img" />
    <div class="tips">
      <template v-if="type == FANS.DEMAND_POOL.CATEGORY_LIST[0].sort">
        {{ '暂无最新任务，来提交你的需求吧' }}
      </template>
      <template v-if="type == FANS.DEMAND_POOL.CATEGORY_LIST[1].sort">
        {{ '暂无同求最多的任务，请耐心等待哦' }}
      </template>
      <template v-if="type == FANS.DEMAND_POOL.CATEGORY_LIST[2].sort">
        {{ '暂无完成的任务，请耐心等待哦' }}
      </template>
      <template v-if="type == FANS.DEMAND_POOL.CATEGORY_LIST[3].sort">
        {{ '您还没有提交设计需求' }}
      </template>
    </div>
    <div class="submit" @click="writeDemand">提交需求</div>
  </div>
</template>

<script>
import {FANS} from "@/constant/fans/FANS";

export default {
  name: "DemandPoolListEmpty",
  props: {
    type: {
      type: String,
      default: 'new'
    }
  },
  data() {
    return {
      FANS
    }
  },
  methods:{
    writeDemand(){
      this.$emit('writeDemand')
    }
  }
}
</script>

<style lang="scss" scoped>
.DemandPoolListEmpty {
  width: 1440px;
  height: 500px;
  background: #FFFFFF;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .empty-img {
    width: 186px;
    height: 100px;
    margin: 103px 0 32px;
    @include BgImage(186px,100px,'fans/demand-pool/empty-img.png')
  }

  .tips {
    margin-bottom: 24px;
    height: 20px;
    font-size: 14px;
    color: #001013;
    line-height: 20px;
  }

  .submit {
    width: 170px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: #FF5D6E;
    border-radius: 24px;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
    @include ElementHover('', $color-fans-hover);
  }
}
</style>
